import { MigrationInterface, QueryRunner } from 'typeorm'
import { Domain, getRepository } from '@things-factory/shell'
import { Kpi, KpiStatus, KpiPeriodType, KpiVizType } from '../service/kpi/kpi'
import * as fs from 'fs'
import * as path from 'path'

const SEED = [
  // 일정성과 (Y1) - Schedule Performance
  {
    name: '연면적 대비 공사기간',
    description: '연면적 대비 공사기간 평가',
    categoryName: '일정성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '설계변경에 따른 공기 증감률',
    description: '설계변경에 따른 공기 증감률 평가',
    categoryName: '일정성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '일정 이탈 수준',
    description: '프로젝트 일정 이탈 수준 평가',
    categoryName: '일정성과',
    formula: 'Table(DART 등) 활용(1~5점)',
    scoreType: 'table',
    dataType: 'score'
  },
  {
    name: '일정성과 수준 평가',
    description: '일정성과 종합 평가',
    categoryName: '일정성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  },

  // 비용성과 (Y2) - Cost Performance
  {
    name: '연면적 대비 공사비',
    description: '연면적 대비 공사비 평가',
    categoryName: '비용성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '설계변경에 따른 공사비 증감률',
    description: '설계변경에 따른 공사비 증감률 평가',
    categoryName: '비용성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '비용성과 수준 평가',
    description: '비용성과 종합 평가',
    categoryName: '비용성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  },

  // 품질성과 (Y3) - Quality Performance
  {
    name: '품질시험 불합격률',
    description: '품질시험 불합격률 평가',
    categoryName: '품질성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '검수자재 불합격률',
    description: '검수자재 불합격률 평가',
    categoryName: '품질성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '검측 불합격률',
    description: '검측 불합격률 평가',
    categoryName: '품질성과',
    formula: 'Table 활용',
    scoreType: 'table',
    dataType: 'score'
  },
  {
    name: '품질 SL-PA 결과값',
    description: '품질 SL-PA 결과',
    categoryName: '품질성과',
    formula: 'Python 활용(1~5점)',
    scoreType: 'python',
    dataType: 'score'
  },
  {
    name: '품질성과 수준 평가',
    description: '품질성과 종합 평가',
    categoryName: '품질성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  },

  // 안전성과 (Y4) - Safety Performance
  {
    name: '재해율',
    description: '재해율 평가',
    categoryName: '안전성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '재해강도율',
    description: '재해강도율 평가',
    categoryName: '안전성과',
    formula: 'Table 활용',
    scoreType: 'table',
    dataType: 'score'
  },
  {
    name: '안전 SL-PA 결과값',
    description: '안전 SL-PA 결과',
    categoryName: '안전성과',
    formula: 'Python 활용(1~5점)',
    scoreType: 'python',
    dataType: 'score'
  },
  {
    name: '안전성과 수준 평가',
    description: '안전성과 종합 평가',
    categoryName: '안전성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  },

  // 환경성과 (Y5) - Environmental Performance
  {
    name: '건설폐기물 발생량',
    description: '건설폐기물 발생량 평가',
    categoryName: '환경성과',
    formula: 'Table 활용',
    scoreType: 'table',
    dataType: 'score'
  },
  {
    name: '환경성과 수준 평가',
    description: '환경성과 종합 평가',
    categoryName: '환경성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  },

  // 생산성성과 (Y6) - Productivity Performance
  {
    name: '투입인력 생산성',
    description: '투입인력 생산성 평가',
    categoryName: '생산성과',
    formula: 'Eq. 활용',
    scoreType: 'equation',
    dataType: 'ratio'
  },
  {
    name: '생산성성과 수준 평가',
    description: '생산성과 종합 평가',
    categoryName: '생산성과',
    formula: '감리자 1~5점 척도',
    scoreType: 'inspector',
    dataType: 'score'
  }
]

interface KpiSeedData {
  name: string
  description: string
  formula?: string | null
  active: boolean
  state?: string | null
  viz_type?: string | null
  viz_meta?: any | null
  schedule?: string | null
  schedule_id?: string | null
  timezone?: string | null
  grades?: any | null
  period_type: string
  weight: number
  score_formula?: string | null
  is_leaf: boolean
  parent_name?: string | null
}

export class SeedKpi1752190849681 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<any> {
    try {
      const repository = getRepository(Kpi)
      const domainRepository = getRepository(Domain)

      // SYSTEM 도메인 확인
      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('❌ SYSTEM domain not found')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpis-seed.json')
      const seedData: KpiSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      // 이름으로 KPI를 찾을 수 있는 맵 생성
      const kpiNameMap = new Map<string, Kpi>()

      // 1단계: parent_name이 null인 루트 KPI들 먼저 생성
      const rootKpis = seedData.filter(kpi => kpi.parent_name === null)

      for (const kpiData of rootKpis) {
        const existingKpi = await repository.findOne({
          where: { name: kpiData.name, domain: { id: domain.id } }
        })

        if (existingKpi) {
          console.log(`⚠️  KPI already exists: ${kpiData.name}`)
          kpiNameMap.set(kpiData.name, existingKpi)
          continue
        }

        const kpi = await repository.save({
          name: kpiData.name,
          description: kpiData.description,
          formula: kpiData.formula,
          active: kpiData.active,
          state: kpiData.state ? KpiStatus[kpiData.state as keyof typeof KpiStatus] : KpiStatus.DRAFT,
          vizType: kpiData.viz_type ? KpiVizType[kpiData.viz_type as keyof typeof KpiVizType] : null,
          vizMeta: kpiData.viz_meta,
          schedule: kpiData.schedule,
          scheduleId: kpiData.schedule_id,
          timezone: kpiData.timezone,
          grades: kpiData.grades ? JSON.parse(kpiData.grades) : null,
          periodType: KpiPeriodType[kpiData.period_type as keyof typeof KpiPeriodType],
          weight: kpiData.weight,
          scoreFormula: kpiData.score_formula,
          isLeaf: kpiData.is_leaf,
          parent: null,
          domain
        })

        kpiNameMap.set(kpi.name, kpi)
        console.log(`✅ Created root KPI: ${kpi.name}`)
      }

      // 2단계: 자식 KPI들 생성 (parent_name이 있는 KPI들)
      const childKpis = seedData.filter(kpi => kpi.parent_name !== null)

      for (const kpiData of childKpis) {
        const existingKpi = await repository.findOne({
          where: { name: kpiData.name, domain: { id: domain.id } }
        })

        if (existingKpi) {
          console.log(`⚠️  KPI already exists: ${kpiData.name}`)
          continue
        }

        // 부모 KPI 찾기
        const parentKpi = kpiNameMap.get(kpiData.parent_name!)
        if (!parentKpi) {
          console.log(`❌ Parent KPI not found: ${kpiData.parent_name} for ${kpiData.name}`)
          continue
        }

        const kpi = await repository.save({
          name: kpiData.name,
          description: kpiData.description,
          formula: kpiData.formula,
          active: kpiData.active,
          state: kpiData.state ? KpiStatus[kpiData.state as keyof typeof KpiStatus] : KpiStatus.DRAFT,
          vizType: kpiData.viz_type ? KpiVizType[kpiData.viz_type as keyof typeof KpiVizType] : null,
          vizMeta: kpiData.viz_meta,
          schedule: kpiData.schedule,
          scheduleId: kpiData.schedule_id,
          timezone: kpiData.timezone,
          grades: kpiData.grades ? JSON.parse(kpiData.grades) : null,
          periodType: KpiPeriodType[kpiData.period_type as keyof typeof KpiPeriodType],
          weight: kpiData.weight,
          scoreFormula: kpiData.score_formula,
          isLeaf: kpiData.is_leaf,
          parent: parentKpi,
          domain
        })

        kpiNameMap.set(kpi.name, kpi)
        console.log(`✅ Created child KPI: ${kpi.name} (parent: ${parentKpi.name})`)
      }

      console.log(`🎉 Successfully processed ${seedData.length} KPIs from JSON seed`)
    } catch (error) {
      console.error('❌ Error seeding KPIs from JSON:', error)
      throw error
    }
  }

  public async down(queryRunner: QueryRunner): Promise<any> {
    try {
      const repository = getRepository(Kpi)
      const domainRepository = getRepository(Domain)

      const domain: Domain = await domainRepository.findOneBy({ name: 'SYSTEM' })
      if (!domain) {
        console.log('⚠️  SYSTEM domain not found. Nothing to delete.')
        return
      }

      // JSON 파일 읽기
      const seedFilePath = path.join(__dirname, 'seed-data', 'kpis-seed.json')
      const seedData: KpiSeedData[] = JSON.parse(fs.readFileSync(seedFilePath, 'utf8'))

      // 자식부터 삭제 (역순으로)
      const childKpis = seedData.filter(kpi => kpi.parent_name !== null).reverse()
      const rootKpis = seedData.filter(kpi => kpi.parent_name === null).reverse()

      // 자식 KPI들 먼저 삭제
      for (const kpiData of childKpis) {
        const kpi = await repository.findOne({
          where: { name: kpiData.name, domain: { id: domain.id } }
        })
        if (kpi) {
          await repository.delete(kpi.id)
          console.log(`✅ Deleted child KPI: ${kpiData.name}`)
        }
      }

      // 루트 KPI들 삭제
      for (const kpiData of rootKpis) {
        const kpi = await repository.findOne({
          where: { name: kpiData.name, domain: { id: domain.id } }
        })
        if (kpi) {
          await repository.delete(kpi.id)
          console.log(`✅ Deleted root KPI: ${kpiData.name}`)
        }
      }

      console.log(`🎉 Successfully cleaned up KPIs from JSON seed`)
    } catch (error) {
      console.error('❌ Error cleaning up KPIs:', error)
      throw error
    }
  }
}
